<template>
  <div style="overflow: hidden">
    <!-- 弹出框组件 -->
    <device-dialog ref="dialog" :Devicelistname="checkboxlistid" :types="type" :title="dialogtitle"
      :TimedRestart="TimedRestart" @RemType="RemType" @close="this.type = ''" />
    <!-- 顶部定时刷新-批量分组 -->
    <div style="float: right">
      <el-button v-if="IsGroupRouter" size="mini" type="primary">返回</el-button>
      <!-- 批量修改分组 -->
      <el-button size="mini" type="primary" @click="changeDeviceGroupdialog" v-if="Permission.indexOf(181) != -1">{{
        $t('lang.devicelist.batch_groups_path') }}</el-button>
      <!--定时刷新-->
      <el-select v-model="time" size="mini" class="selectlist">
        <el-option v-for="item in setTime" :key="item.value" :label="item.name" :value="item.value"></el-option>
      </el-select>
    </div>
    <!--xlsx表格导出-->
    <xlsx v-if="Permission.indexOf(94) != -1"></xlsx>
    <!-- 远程操作下拉菜单 -->
    <el-select v-model="type" :placeholder="$t('lang.devicelist.Please')" size="mini"
      style="margin: 0.2rem 0.2rem 0.2rem 0rem" @change="getype" v-if="Permission.indexOf(96) != -1" clearable>
      <el-option v-for="item in typelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <!-- 设备检测 -->
    <el-button v-if="userId === 1" size="mini" type="primary" @click="openDetectionDialog">{{
      $t('lang.devicelist.Detection') }}</el-button>
    <!-- 表格 -->
    <div style="width: 100%;white-space:nowrap;">
      <TableComponent ref="deviceTable" :Columns="Columns" :data="list" :RowKey="'deviceId'"
        :ColuumnsButton="ColuumnsButton" :ColuumnsButtonWidth="280" :seek="seek" @GetStatus="GetStatus"
        @goparticulars="goparticulars" @remdevice="remdevice" @gogateone="gogateone" @closeRemote="closeRemote"
        @SetDisabled="SetDisabled" @SetRepair="SetRepair" @sortChange="sortChange" @GetSeek="GetSeek"
        @GetOnlineTime="GetOnlineTime" @GetOffOrOnTime="GetOffOrOnTime" @showOnAndOf="showOnAndOf"
        @handleSelectionChange="handleSelectionChange" @repair="openRepairDevice">
        <span slot="slot" slot-scope="scope" style="color:#409eff;font-size:15px;">{{ scope.scope.$index }}</span>
        <span slot="customColumn" slot-scope="scope" style="font-size:15px;">{{ scope.scope.row.deviceSn }}&nbsp;</span>
      </TableComponent>
    </div>
    <!--分页组件-->
    <div style="overflow: hidden">
      <pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
        @CurrentChanges="CurrentChanges"></pagination>
    </div>
    <!--批量修改分组-->
    <el-dialog :title="$t('lang.devicelist.changes')" :visible.sync="centerDialogVisibles" width="40%" center>
      <p style="text-align: center">
        <span class="tetxp">{{ $t('lang.devicelist.Primary') }}：</span>
        <el-select v-model="group_level1" :placeholder="$t('lang.devicelist.PLEASE')" size="mini" style="width: 5rem"
          @change="getgroup_level1" filterable clearable remote :remote-method="filterMethod">
          <el-option v-for="item in Grouping" :key="item.group_id" :label="item.group_name"
            :value="item.group_id"></el-option>
        </el-select>
      </p>
      <p style="text-align: center">
        <span class="tetxp">{{ $t('lang.devicelist.secondary') }}：</span>
        <el-select v-model="group_level2" :placeholder="$t('lang.devicelist.Choose')" size="mini" style="width: 5rem"
          filterable @change="getgroup_level2" clearable>
          <el-option v-for="item in groupList" :key="item.group_id" :label="item.group_name"
            :value="item.group_id"></el-option>
        </el-select>
      </p>
      <p style="text-align: center">
        <span class="tetxp">{{ $t('lang.devicelist.highlevel') }}：</span>
        <el-select v-model="group_level3" :placeholder="$t('lang.devicelist.Choose')" size="mini" filterable
          style="width: 5rem" clearable>
          <el-option v-for="item in groupLists" :key="item.group_id" :label="item.group_name"
            :value="item.group_id"></el-option>
        </el-select>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="centerDialogVisibles = false">{{ $t('lang.devicelist.CancelTst') }}</el-button>
        <el-button size="mini" type="primary" @click="changeDeviceGroup">{{ $t('lang.devicelist.Determine')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('lang.Dialog.affected')" :visible.sync="centerDialogVisible" width="40%" center>
      <span slot="footer" class="dialog-footer">
        <span>{{ $t('lang.Dialog.affected') }}</span>
        <el-button size="mini" @click="centerDialogVisible = false">{{ $t('lang.Button.cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="centerDialogVisible = false">{{ $t('lang.Button.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <onAndOf ref="showOnAndOf"></onAndOf>
    <!-- 设备检测状态dialog -->
    <el-dialog :title="$t('lang.devicelist.Detection')" :visible.sync="centerDialogVisible" width="40%" center
      @close="closeRepairDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        {{ progress !== '' ? progress : $t('lang.devicelist.confirmRepir') }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="centerDialogVisible = false">{{
          $t('lang.Button.cancel') }}</el-button>
        <el-button size="mini" :loading="centerDialogLoading" type="primary" @click="detection">{{
          $t('lang.Button.confirm') }}</el-button>
      </span>
      <!-- <el-table :data="list" style="width: 100%">
      </el-table> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceList,
  deleteDevice,
  queryKeyword,
  getAddLevel3Group,
  changeDeviceGroup,
  closeRemote,
  updateDevice,
  repairDevice,
  repairAllDevice,
  repairProgress
} from "@/api/devicelist"
// import {
//   getRemoteLink,
// } from "@/api/gateone"
import { mapActions, mapGetters } from "vuex"
import pagination from "@/components/pagination"
import xlsx from "@/components/xlsx"
import DeviceDialog from "../components/Dialog"
import { getPermission } from "../../../cookie/cookie"
import { GetTaskId, SetTaskId, ClearTaskId, getuser_id } from "@/localStorage/localStorage";
import { PublicComponent } from "../../../mixins/common"
import TableComponent from '@/components/TableComponent/index'
import { Columns, ColuumnsButton } from './TableConfig'
import { getDuration } from "../../../utils/Date"
import { listConfig } from '@/api/configurationlist'
import onAndOf from "../components/onAndOf.vue"
import { compareVersion } from "@/utils/Date"
import { debounce } from "lodash";
import { getDeviceMqttStatus } from "@/api/configurationlist";
export default {
  name: 'DeviceList',
  mixins: [PublicComponent],
  data() {
    return {
      //表格组件配置
      Columns: Columns,
      ColuumnsButton: ColuumnsButton,
      //用户权限
      Permission: [],
      //table数据集(后端获取)
      list: [],
      //弹出层控制
      centerDialogVisible: false,
      //修改分组弹层
      centerDialogVisibles: false,
      //定时刷新数据
      setTime: [
        { name: this.$t("lang.devicelist.batch"), value: 99999999999 },
        { name: this.$t("lang.devicelist.L5Nrefresh"), value: 5000 },
        { name: this.$t("lang.devicelist.L10Nrefresh"), value: 10000 },
        { name: this.$t("lang.devicelist.L20Nrefresh"), value: 20000 },
        { name: this.$t("lang.devicelist.L60Nrefresh"), value: 60000 }
      ],
      time: 10000,
      //定时函数
      setIntervals: null,
      //搜索框绑定值
      seek: {
        deviceSn: "", //序列号
        deviceGname: "", //组名
        deviceName: "", //设备名
        deviceIp: "", //ip地址
        deviceIsconnected: "", //状态‘3’表示连接，其他断开'
        deviceTraffic: "", //流量
        signalStrength: "", //信号强度
        nettype: "", //网络制式0   NONE 1 GSM 2 GPRS 3 CDMA&EVDO 4 CDMA 5 EVDO 6 WCDMA 7 HSDPA 8 HSUPA 9 HSPA+ 10 TD-SCDMA 11 FDD-LTE 12 TD-LTE 13 AUTO
        deviceOnlinetime: "", //在线时长
        // deviceOnline:"",
        deviceUpdate: "", //最后活跃
        deviceSoftwareVer: "", //软件版本
        deviceAddress: "", //设备位置
        iccid: ""//iccid
      },
      //分组列表
      groupList: [],
      groupLists: [],
      //一二三级分组
      group_level1: null,
      group_level2: null,
      group_level3: null,
      //表格选中值
      checkboxlist: [],
      //获取选中的设备id
      checkboxlistid: new Set(),
      type: "",
      //远程功能操作选项
      typelist: [
        {
          value: "3",
          label: this.$t("lang.devicelist.restart")
        },
        {
          value: "4",
          label: this.$t("lang.devicelist.Factory")
        },
        {
          value: "5",
          label: this.$t("lang.devicelist.Backup")
        },
        {
          value: "6",
          label: this.$t("lang.devicelist.personsto")
        },
        {
          value: "10",
          label: this.$t("lang.devicelist.Timer")
        },
        {
          value: "11",
          label: this.$t("lang.devicelist.Prototype")
        },
        {
          value: '12',
          label: this.$t('lang.devicelist.reloadM2M')
        }
      ],
      //弹出框标题
      dialogtitle: "",
      //表格排序
      sort: {
        sn: null, //序列号
        groupname: null, //设备分组
        devicename: null, //设备名称
        ip: null, //ip地址
        isconnected: null, //连接状态
        traffic: null, //流量
        signalstrength: null, //信号强度
        nettype: null, //网络制式
        olinetime: null, //在线时长
        offlinetime: null, //最后活跃
        version: null, //软件版本
        address: null, //设备位置
        traffic3: null, //流量
        traffic1: null, //流量
        traffic2: null, //流量
      },
      //连接gateone定时器
      settime: null,
      //当前选中的设备服务类型
      groupType: null,
      //控制table是否显示
      ShowTable: true,
      //是否是从分组列表中跳转
      IsGroupRouter: false,
      //定时重启选中值(选中一个设备时)
      TimedRestart: {},
      groupValue: {
        l1: '',
        l2: '',
        l3: '',
      },
      centerDialogVisible: false,
      centerDialogLoading: false,
      progress: '',
      repairTaskId: null,
      repairTaskTime: null,
      userId: undefined,
    };
  },
  computed: {
    ...mapGetters(["GroupingName", "Grouping"]),
    //vuex getters计算属性，用于实习监听
    GetGroupingNames() {
      return this.GroupingName;
    }
  },

  mounted() {
    this.userId = Number(getuser_id());

    //判断是从分组列表跳转(获取vuex)
    if (this.GroupingName != "") {
      this.Gid = this.GroupingName;
      this.stodevicelist();
    } else {
      this.getDeviceList();
    }
    //开启定时刷新定时器，默认10秒
    this.setIntervals = setInterval(() => {
      this.stodevicelist();
    }, this.time);
    //获取权限
    this.Permission = getPermission();
  },
  methods: {
    ...mapActions(["GetGroupingName", "getLevel3Group", "ShowKeepAlive", "setMonitorGroup"]),
    //获取设备列表
    getDeviceList() {
      getDeviceList(this.offset, this.limit).then(res => {
        if (res.data.data.list.length > 0) {
          this.list = res.data.data.list
          this.list.unshift({})
          this.list.forEach(val => {
            //添加设备名称修改输入框显示隐藏布尔值
            this.$set(val, "nameedac", false)
            //添加设备位置修改输入框显示隐藏布尔值
            this.$set(val, "Addressedac", false)
          });
          this.offset = res.data.data.offset;
          this.limit = res.data.data.limit;
          this.total = res.data.data.total;
        } else if (res.data.data.list.length == 0 && this.offset > 1) {
          this.offset -= 1;
          getDeviceList(this.offset, this.limit).then(res => {
            this.list = res.data.data.list;
            this.list.unshift({});
            this.list.forEach(val => {
              //添加设备名称修改输入框显示隐藏布尔值
              this.$set(val, "nameedac", false);
              //添加设备位置修改输入框显示隐藏布尔值
              this.$set(val, "Addressedac", false);
            });
            this.offset = res.data.data.offset;
            this.limit = res.data.data.limit;
            this.total = res.data.data.total;
          });
        }
      });
    },
    // 搜索分组
    filterMethod(value) {
      this.setMonitorGroup(value);
      this.getLevel3Group(0);
    },
    //跳转设备详情页
    goparticulars(row) {
      this.$router.push({
        path: `/device/particulars/${row.deviceId}/${row.deviceDid
          }`
      });
    },
    //删除设备
    remdevice(row) {
      deleteDevice(row.deviceId).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message1"),
            type: "success"
          });
          this.queryKeyword();
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message2"),
            type: "warning"
          });
          this.queryKeyword();
        }
      });
    },
    //定时刷新搜索函数
    stodevicelist() {
      this.queryKeyword();
    },
    //获取二级分组
    getgroup_level1(val) {
      this.group_level2 = null;
      this.group_level3 = null;
      this.groupValue.l1 = val;
      getAddLevel3Group(val)
        .then((res) => {
          this.groupList = res.data.queryResult
        })
    },
    //获取三级分组
    getgroup_level2(val) {
      this.group_level3 = null;
      this.groupValue.l2 = val;
      getAddLevel3Group(val)
        .then((res) => {
          this.groupLists = res.data.queryResult
        })
    },
    //表格选择框
    handleSelectionChange(val) {
      //清除值
      this.checkboxlistid = new Set();
      this.checkboxlistid.clear();
      //获取选中列表
      this.checkboxlist = val;
      //拿到所有需要的参数
      this.checkboxlist.forEach((value, index, arr) => {
        this.checkboxlistid.add({
          deviceId: value.deviceId,
          deviceName: value.deviceName,
          deviceDid: value.deviceDid,
          deviceType: value.groupType,
          deviceIsconnected: value.deviceIsconnected,
          deviceSn: value.deviceSn,
        });
      });
    },
    //批量修改分组弹出
    changeDeviceGroupdialog() {
      if (this.checkboxlistid.size === 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.devicelist.message3"),
          type: "warning"
        });
        this.type = "";
        return;
      } else {
        //获取当前最新的一级分组列表
        this.getLevel3Group(0);
        this.centerDialogVisibles = true;
      }
    },
    //修改设备分组
    changeDeviceGroup() {
      let Arr = [];
      this.checkboxlistid.forEach((value, index, arr) => {
        Arr.push(parseInt(value.deviceId));
      });
      let group_level = null;
      if (this.group_level3 !== null) {
        group_level = this.group_level3;
      } else if (this.group_level2 !== null) {
        group_level = this.group_level2;
      } else if (this.group_level1 !== null) {
        group_level = this.group_level1;
      }
      changeDeviceGroup(Arr, group_level).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message4"),
            type: "success"
          });
          this.queryKeyword();
          this.centerDialogVisibles = !this.centerDialogVisibles;
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message5"),
            type: "warning"
          });
          this.queryKeyword();
        }
        // deviceTable
        this.$refs.deviceTable.cancelSelect()
      });
    },
    //跳转gateone
    gogateone(row) {
      //打开新的窗口操作gateone
      let { href } = this.$router.resolve({
        path: `/gateone/${row.deviceDid}/${row.deviceSn}`
      });
      window.open(href, "_blank");
    },
    //获取下拉框指令
    getype(e) {
      if (e == '' || (!e)) {
        return
      }
      if (e == 12) {
        if (this.checkboxlistid.size == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message6"),
            type: "warning"
          });
          this.type = "";
          return
        }
        this.dialogtitle = this.$t('lang.devicelist.reloadM2M');
        this.$refs.dialog.showDialog();
        return
      }
      //跳出函数控制变量
      let show = true;
      //判断当前选中设备是否有未在线的
      this.checkboxlistid.forEach((val, index) => {
        if (val.deviceIsconnected != 3) {
          show = false;
        }
      });
      //如果有未在线的失败提示用户并且跳出函数
      if (!show) {
        this.$message({
          showClose: true,
          message: this.$t("lang.devicelist.message6"),
          type: "warning"
        });
        this.type = "";
        return;
      }
      //选择获取设备日志or备份配置文件
      if (this.type == "5" || this.type == "6") {
        if (this.checkboxlistid.size > 1) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message7"),
            type: "warning"
          });
          this.type = "";
          return;
        }
      }
      //选择定时重启
      if (this.type == '10' && this.checkboxlistid.size == 1) {
        listConfig(this.checkboxlist[0].deviceSn, this.checkboxlist[0].deviceDid, [{
          section: "reboot",
          config: "reboot",
          options: [
            { option: "enabled" }]
        }]).then(res => {
          console.log(res);
          let status = res.data.data.mess[0].s_objects[0].options.enabled
          console.log(status);
          if (status == 1) {
            listConfig(this.checkboxlist[0].deviceSn, this.checkboxlist[0].deviceDid, [{
              section: "reboot",
              config: "reboot",
              options: [
                { option: "hour" },
                { option: "min" },
                { option: "period" }]
            }])
              .then((res) => {
                //数据解构
                const { hour, min, period } = res.data.data.mess[0].s_objects[0].options
                this.TimedRestart = { hour, min, period }
              })
          }
        })
      }
      if (this.checkboxlist.length < 1) {
        this.$message({
          showClose: true,
          message: this.$t("lang.devicelist.message8"),
          type: "warning"
        });
        this.type = "";
        return;
      } else {
        //拿到当前选中的操作的名称
        this.typelist.forEach((val, index, arr) => {
          if (val.value.includes(this.type)) {
            this.dialogtitle = val.label;
          }
        });
        this.$refs.dialog.showDialog();
      }
    },
    //表格搜索
    queryKeyword() {
      queryKeyword(
        this.offset,
        this.limit,
        [
          this.seek.deviceSn,
          this.seek.deviceGname,
          this.seek.deviceName,
          this.seek.deviceIp,
          this.seek.deviceIsconnected,
          this.seek.deviceTraffic,
          this.seek.signalStrength,
          this.seek.nettype,
          this.seek.deviceOnlinetime,
          // this.seek.deviceOnline,
          this.seek.deviceUpdate,
          this.seek.deviceSoftwareVer,
          this.seek.deviceAddress,
          this.seek.iccid,
        ],
        this.sort,
        this.Gid
      ).then(res => {
        if (res.data.data.list.length > 0) {
          this.list = res.data.data.list;
          this.limit = res.data.data.limit;
          this.offset = res.data.data.offset;
          this.total = res.data.data.total;
          this.list.unshift({});
          this.list.forEach(val => {
            //添加设备名称修改输入框显示隐藏布尔值
            this.$set(val, "nameedac", false);
            //添加设备位置修改输入框显示隐藏布尔值
            this.$set(val, "Addressedac", false);
          });
        } else {
          this.list = res.data.data.list;
          this.list.unshift({});
          this.list.forEach(val => {
            //添加设备名称修改输入框显示隐藏布尔值
            this.$set(val, "nameedac", false);
            //添加设备位置修改输入框显示隐藏布尔值
            this.$set(val, "Addressedac", false);
          });
        }
      });
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        sn: null, //序列号
        groupname: null, //设备分组
        devicename: null, //设备名称
        ip: null, //ip地址
        isconnected: null, //连接状
        traffic: null, //流量
        signalstrength: null, //信号强度
        nettype: null, //网络制式
        olinetime: null, //在线时长
        offlinetime: null, //最后活跃
        version: null, //软件版本
        address: null, //设备位置
        traffic3: null, //流量
        traffic2: null, //流量
        traffic1: null, //流量
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.devicelist.Serial")) {
        this.sort.sn = sortlist;
      } else if (label == this.$t("lang.devicelist.Equipment")) {
        this.sort.groupname = sortlist;
      } else if (label == this.$t("lang.devicelist.DeviceName")) {
        this.sort.devicename = sortlist;
      } else if (label == this.$t("lang.devicelist.IP")) {
        this.sort.ip = sortlist;
      } else if (label == this.$t("lang.devicelist.statevoid")) {
        this.sort.isconnected = sortlist;
      } else if (label == this.$t("lang.devicelist.traffic")) {
        this.sort.traffic = sortlist;
      } else if (label == this.$t("lang.devicelist.signal")) {
        this.sort.signalstrength = sortlist;
      } else if (label == this.$t("lang.devicelist.racingnetwork")) {
        this.sort.nettype = sortlist;
      } else if (label == this.$t("lang.devicelist.XoopsOnlineHandler")) {
        this.sort.olinetime = sortlist;
      } else if (label == this.$t("lang.devicelist.TimeSeries")) {
        this.sort.offlinetime = sortlist;
      } else if (label == this.$t("lang.devicelist.Version")) {
        this.sort.version = sortlist;
      } else if (label == this.$t("lang.devicelist.schemaLocation")) {
        this.sort.address = sortlist;
      } else if (label == this.$t("lang.devicelist.WANPortTraffic")) {
        this.sort.traffic1 = sortlist;
      } else if (label == this.$t("lang.devicelist._3GWAN1Traffic")) {
        this.sort.traffic2 = sortlist;
      } else if (label == this.$t("lang.devicelist._3GWAN2Traffic")) {
        this.sort.traffic3 = sortlist;
      }
    },
    //获取gateone状态
    // getRemoteLink(did) {
    //   getRemoteLink(did).then(res => {
    //     if (res.data.code === 0) {
    //       this.$message({
    //         showClose: true,
    //         message: this.$t("lang.devicelist.message9"),
    //         type: "success"
    //       });
    //       let { href } = this.$router.resolve({ path: `/gateone/${did}` });
    //       window.open(href, "_blank");
    //     } else if (res.data.code === 1) {
    //       this.$message({
    //         showClose: true,
    //         message: this.$t("lang.devicelist.message10"),
    //         type: "error"
    //       });
    //     } else if (res.data.code === 25) {
    //       this.$message({
    //         showClose: true,
    //         message: this.$t("lang.devicelist.message11"),
    //         type: "error"
    //       });
    //     }
    //   });
    // },
    //关闭远程连接
    closeRemote(row) {
      closeRemote(row.deviceDid).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message12"),
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message13"),
            type: "warning"
          });
        }
      });
    },
    //显示修改设备名称输入框
    shownameedac(index) {
      this.list[index].nameedac = true;
      //显示修改输入框时停止定时刷新，因每次获取到列表需要添加显示隐藏输入框布尔值，列表数据有变动，
      //列表会重新渲染
      clearInterval(this.setIntervals);
    },
    //显示修改设备位置输入框
    showAddressedac(index) {
      this.list[index].Addressedac = true;
      //显示修改输入框时停止定时刷新，因每次获取到列表需要添加显示隐藏输入框布尔值，列表数据有变动，
      //列表会重新渲染
      clearInterval(this.setIntervals);
    },
    //修改设备名称
    updateDevicename(index) {
      if (this.list[index].deviceName == "") {
        this.$message({
          showClose: true,
          message: this.$t("lang.devicelist.message14"),
          type: "warning"
        });
        return;
      }
      updateDevice(
        this.list[index].deviceId,
        this.list[index].deviceName,
        this.list[index].deviceAddress
      ).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message15"),
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message16"),
            type: "warning"
          });
        }
        this.list[index].nameedac = false;
        //重新开启定时器
        this.setIntervals = setInterval(() => {
          this.stodevicelist();
        }, this.time);
      });
    },
    //修改设备位置
    updateDeviceAddress(index) {
      if (this.list[index].deviceAddress == "") {
        this.$message({
          showClose: true,
          message: this.$t("lang.devicelist.message17"),
          type: "warning"
        });
        return;
      }
      updateDevice(
        this.list[index].deviceId,
        this.list[index].deviceName,
        this.list[index].deviceAddress
      ).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message15"),
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.devicelist.message16"),
            type: "warning"
          });
        }
        this.list[index].Addressedac = false;
        //重新开启定时器
        this.setIntervals = setInterval(() => {
          this.stodevicelist();
        }, this.time);
      });
    },
    //清除下拉框选项
    RemType() {
      this.type = "";
      this.TimedRestart = {}
    },

    //表格状态
    GetStatus(status) {
      return { status: status == 3 ? 'success' : 'danger', TagName: status == 3 ? this.$t("lang.devicelist.connected") : this.$t("lang.devicelist.not") }
    },
    //gateone按钮状态
    SetDisabled(status, ver) {
      if (compareVersion(ver, 'v2.9') != 1) {
        return status == 3 ? false : true
      } else {
        return true
      }
    },
    // 修复按钮状态
    SetRepair(isCheck) {
      return isCheck == '1'
    },
    //获取在线时长
    GetOnlineTime(row) {
      return getDuration(row.deviceOnlinetime)
    },
    //通过在线状态获取上线离线时间
    GetOffOrOnTime(row) {
      return row.deviceIsconnected == 3 ? row.deviceOnline : row.deviceOffline
    },
    //获取搜索框变化
    GetSeek(seek) {
      this.seek = seek
    },
    //查看上线先记录
    showOnAndOf(v) {
      this.$refs['showOnAndOf'].show = true
      this.$refs['showOnAndOf'].refresh(v)
    },
    async openRepairDevice(v) {
      const res = await getDeviceMqttStatus(v.deviceSn)
      if (!res.data.online) {
        this.$message.error(this.$t('lang.webssh.DeviceMQTToffline'));
        this.loading = false;
        return
      }
      const h = this.$createElement;
      this.$msgbox({
        title: this.$t('lang.Dialog.prompt'),
        message: h('p', null, this.$t('lang.devicelist.repair')),
        showCancelButton: true,
        confirmButtonText: this.$t('lang.Dialog.Determine'),
        cancelButtonText: this.$t('lang.Dialog.cancel'),
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = this.$t('lang.devicelist.progress');
            await repairDevice(v.deviceSn);
            instance.confirmButtonLoading = false;
            done();
          } else {
            done();
          }
        }
      }).then(action => {
        this.$message({
          type: 'info',
          message: this.$t('lang.devicelist.contactCustomerService')
        });
      });
    },
    openDetectionDialog() {
      this.centerDialogVisible = true;
    },
    async detection() {
      this.centerDialogLoading = true;
      if (GetTaskId()) {
        this.repairTaskId = GetTaskId();
        this.progress = this.$t('lang.devicelist.waitRun');
        if (this.repairTaskTime) {
          clearInterval(this.repairTaskTime)
        }
        this.repairTaskTime = setInterval(() => {
          this.getTaskProgress()
        }, 3000)
        return;
      }
      const resp = await repairAllDevice();
      this.repairTaskId = resp.data.taskId;
      SetTaskId(resp.data.taskId);
      this.progress = this.$t('lang.devicelist.waitRun');
      if (this.repairTaskTime) {
        clearInterval(this.repairTaskTime)
      }
      this.repairTaskTime = setInterval(() => {
        this.getTaskProgress()
      }, 3000)
    },
    async getTaskProgress() {
      const resp = await repairProgress(this.repairTaskId);
      if (resp.data.completed) {
        if (!resp.data.totalDevices)
          this.progress = this.$t('lang.devicelist.noDeviceRepair');
        clearInterval(this.repairTaskTime);
        this.repairTaskTime = null;
        this.centerDialogLoading = false;
        ClearTaskId();
      } else {
        if (resp.data.data) {
          this.progress = `${this.$t('lang.devicelist.total')}:${resp.data.totalDevices};${this.$t('lang.devicelist.success')}:${resp.data.successDevices.length};${this.$t('lang.devicelist.fail')}:${resp.data.failDevices}`;
        } else {
          this.progress = resp.data.message
        }
      }
    },
    closeRepairDialog() {
      this.centerDialogVisible = false;
      clearInterval(this.repairTaskTime);
      this.repairTaskId = null;
    }
  },
  watch: {
    //监听刷新下拉框
    time(a, b) {
      clearInterval(this.setIntervals);
      this.setIntervals = setInterval(() => {
        this.stodevicelist();
      }, a);
    },
    //监听分组列表跳转
    // GroupingName(NewValue,OldValue){
    //   this.Gid=NewValue
    //   this.queryKeyword()
    // },
    //根据路由清除部分
    '$route'(to, from) {
      if (from.path != '/device/groupinglist') {
        if (from.path.includes('/device/particulars') || from.path == '/system/remoteservice') {
          this.Gid = this.GroupingName
          this.queryKeyword()
        } else {
          this.Gid = ''
        }
      } else {
        this.Gid = this.GroupingName
        this.queryKeyword()
      }
      //当前不是设备列表删除定时器
      if (to.fullPath != '/device/devicelist') {
        clearInterval(this.setIntervals);
      } else {
        //开启定时刷新定时器，默认10秒
        this.setIntervals = setInterval(() => {
          this.stodevicelist();
        }, this.time);
      }
    }
  },
  beforeDestroy() {
    //页面销毁前(路由跳转前删除定时器)
    clearInterval(this.setIntervals);
    this.$store.dispatch("GetGroupingName", "");
  },
  components: {
    pagination,
    xlsx,
    DeviceDialog,
    TableComponent,
    onAndOf
  },
  //创建获取焦点指令
  directives: {
    focus: {
      //自定义获取焦点指令
      inserted: function (el) {
        el.querySelector("input").focus();
      }
    }
  },
  deactivated() {
    clearInterval(this.setIntervals);
    this.$store.dispatch("RemoveGroupingName");
  }
};
</script>
<style scoped>
#addbut {
  width: 0.8rem;
  height: 0.5rem;
  margin-left: 0.2rem;
  margin-top: 0.2rem;
  font-size: 0.3rem;
}

.concen {
  text-align: center;
  margin: 1rem auto;
}

.selectlist {
  width: 2rem;
  margin: 0.2rem;
}

.chaxun {
  float: right;
}

.checkboxlist {
  margin: 0.2rem;
}

.addbut {
  margin: 0.2rem;
}

.addlist {
  text-align: center;
}

.addinputlist {
  margin: 0.2rem;
  height: 0.5rem;
}

.addel-input {
  width: 4rem;
  display: inline-block;
}

.el-table::before {
  height: 0px;
}

.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
  display: block;
  line-height: 41px;
}

.sn {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
}

.courp {
  cursor: pointer;
}

.seekinput {
  border: 1px solid #000000;
}

.el-table__fixed {
  height: auto;
}

.el-table--mini td,
.el-table--mini th {
  padding: 0px;
}

.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden;
}

.el-table--scrollable-x {
  overflow-x: hidden;
}

.el-table__body-wrapper {
  overflow-x: hidden;
}

.el-table__body-wrapper {
  overflow-x: hidden;
}

.is-scrolling-left {
  overflow-x: hidden;
}

.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}

.tetxp {
  display: inline-block;
  width: 2.5rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}

.index {
  font-size: 0.2rem;
  background-color: #409eff;
  color: #ffffff;
  /* border-radius: 25%; */
  padding: 0.08rem;
  -moz-user-select: none;
  /* Firefox私有属性 */
  -webkit-user-select: none;
  /* WebKit内核私有属性 */
  -ms-user-select: none;
  /* IE私有属性(IE10及以后) */
  -khtml-user-select: none;
  /* KHTML内核私有属性 */
  -o-user-select: none;
  /* Opera私有属性 */
  user-select: none;
  /* CSS3属性 */
}
</style>
